import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { Tooltip,MenuItem,FormControl,InputLabel,Select } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import {
    DataGrid,
} from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import FormHelperText from '@mui/material/FormHelperText';
import CarrierTracking from './CarrierTracking'
import LinearProgress from '@mui/material/LinearProgress';
import NorowsData from '../../pages/General/NorowsData'
import CountryDropdown from '../../pages/General/CountryDropdown'
import ProvinceDropdown from '../../pages/General/ProvinceDropdown'
import AddLineItem from '../../pages/General/NewOrder/AddLineItem';
import Notification from '../../pages/General/Notification';
import WidthMaximize from './WidthMaximize'
import { fetchSkuINfo,resetLineItemSettingsState,patchOrderLineItems } from '../../pages/Settings/ProductLineItems/lineitemSettingsSlice';
import { orderUpdateData,resetOrderNotifications,updateBulkDimension,resetOrderUpdateNotifications,postBulkOrderValidation } from '../../pages/Orders/ordersSlice';
import {
    fetchOrderDetail
} from '../../pages/OrderDetail/orderdetailsSlice';
const getUniqueId = () => {
    return "SCIT" + Date.now().toString(36) + Math.random().toString(36).substr(2)
}
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper'
};
const OrderDetailsEditDrawer = ({ visible,onClose,values,dispatchInputChangeCallback,errors,lineItemsData,dispatchCountryCallback,dispatchProvinceCallback, invalidDocIds = null,meta = null  }) => {
    const dispatch = useDispatch();
    const orders = useSelector(state => state.orders);
    const skuInfos = useSelector(state => state.lineitemsettings.skuINfo);
    const box = useSelector(state => state.box)
    const orderDetails = useSelector(state => state.orderdetails);
    const orderUpdate = useSelector(state => state.orders && state.orders.orderUpdate);
    const profile = useSelector(state => state.auth.profile);    
    const [editLineItemId, setEditLineItemId] = useState("")
    const [splitLineItemId, setSplitLineItemId] = useState("")
    const [addLineItemVisible, setAddLineItemVisible] = useState(false)
    const [splitLineItemVisible, setSplitLineItemVisible] = useState(false)
    const [removeLineItemId, setRemoveLineItemId] = useState("")
    const [customLineItems, setCustomLineItems] = useState(lineItemsData)
    const [updateLineItems, setUpdateLineItems] = useState(lineItemsData)
    const [drawerWidth, setDrawerWidth] = useState("80%");
    const [splitQuantityCount, setSplitQuantityCount] = useState("");
    const [splitQuantityError, setSplitQuantityError] = useState("");
    const [boxData, setBoxData] = useState([])
    const [skuInfo, setSkuInfo] = useState([]);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const initialBoxValues = {
        "_id":0,
        "box_name": 'custom',
        "box_length": "",
        "box_width": "",
        "box_height": "",
        "box_dimension_unit": "",
        "box_actual_weight": "",
        "box_weight_unit": "",
        "insurance_amount":"100"
    }
    const [dimensionValue, setDimensionValue] = useState(initialBoxValues);
    const [dimensionsErrors, setDimensionsErrors] = useState({});
    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.box_name,
      });

    const getChooseMeasurement = (currentvalue) => {
    let filteredCurrentValue = {};
    let tempValue = "";
    boxData &&
    boxData.map((key) => {
        if (key._id == currentvalue && tempValue == "") {
            filteredCurrentValue = key;
            tempValue = "success";
        }
        });
    return filteredCurrentValue;
    };

    const onBoxDimensionChange=(event)=>{
        let packageFieldData = {...dimensionValue};
        if(event.target.name==='choosenmeasurement'){
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    if (boxData._id === event.target.value) {
                        setDimensionValue({
                            ...dimensionValue,
                            "_id": event.target.value,
                            "box_name": boxData.box_name,
                            "box_length": parseFloat(boxData.box_length).toFixed(2),
                            "box_width": parseFloat(boxData.box_width).toFixed(2),
                            "box_height": parseFloat(boxData.box_height).toFixed(2),
                            "box_dimension_unit": boxData.box_length_unit,
                            "box_actual_weight": parseFloat(boxData.box_weight).toFixed(2),
                            "box_weight_unit": boxData.box_weight_unit,
                            "insurance_amount": "100"
                        });
                        setDimensionsErrors({})
                    }
                })
            }else{
                setDimensionValue({
                    ...dimensionValue,
                    "_id":0,
                    "box_name": 'custom',
                    "box_length": "",
                    "box_width": "",
                    "box_height": "",
                    "box_dimension_unit": "",
                    "box_actual_weight": "",
                    "box_weight_unit": "",
                    "insurance_amount": "100"
                });
                setDimensionsErrors({})
            }
        }else{
            packageFieldData[event.target.name] = event.target.value;
            setDimensionValue(packageFieldData);
            validator({ [event.target.name]: event.target.value })
        }
    }
    const validator = (fieldValues) => {
        let temp = { ...dimensionsErrors }
        if ('box_name' in fieldValues)
            temp.box_name = fieldValues.box_name ? "" : "This field is required."
        if (fieldValues && fieldValues.box_name && fieldValues.box_name.length < 3)
            temp.box_name = "Box Name required minimum 3 characters"
        if ('box_length' in fieldValues)
            temp.box_length = fieldValues.box_length ? "" : "This field is required."
        if (fieldValues && fieldValues.box_length && fieldValues.box_length <= 0)
            temp.box_length = "Length is not a negative number or 0"
        if ('box_dimension_unit' in fieldValues)
            temp.box_dimension_unit = fieldValues.box_dimension_unit ? "" : "This field is required."
        if ('box_width' in fieldValues)
            temp.box_width = fieldValues.box_width ? "" : "This field is required."
        if (fieldValues && fieldValues.box_width && fieldValues.box_width <= 0)
            temp.box_width = "Width is not a negative number  or 0"
        if ('box_height' in fieldValues)
            temp.box_height = fieldValues.box_height ? "" : "This field is required."
        if (fieldValues && fieldValues.box_height && fieldValues.box_height <= 0)
            temp.box_height = "Height is not a negative number  or 0"
        if ('box_actual_weight' in fieldValues)
            temp.box_actual_weight = fieldValues.box_actual_weight ? "" : "This field is required."
        if (fieldValues && fieldValues.box_actual_weight && fieldValues.box_actual_weight <= 0)
            temp.box_actual_weight = "Weight is not a negative number  or 0"
        if ('box_weight_unit' in fieldValues)
            temp.box_weight_unit = fieldValues.box_weight_unit ? "" : "This field is required."

        setDimensionsErrors({
            ...temp
        })

        if (fieldValues === dimensionValue)
            return Object.values(temp).every(x => x == "")
    }

    const addBulkDimensionsForm =(ids,values)=>{
        const isValid = validator(values)
        if (isValid) {
            let docid={'docids':ids}
            Object.assign(values, docid);
            dispatch(updateBulkDimension(values))
            setDimensionValue(initialBoxValues)
            setDimensionsErrors({})
        }
    }

    useEffect(() => {
        if (orderDetails && orderDetails.data && orderDetails.data.length!==0 && orderDetails.data.product_info) {
            orderDetails.data.product_info.map((item) => {
                setDimensionValue({
                    ...dimensionValue,
                    "_id": 0,
                    "box_name": "",
                    "box_length": item && item.dimensions && item.dimensions.length && item.dimensions.length >0 ? parseFloat(item.dimensions.length).toFixed(2) : 0,
                    "box_width": item &&  item.dimensions.width && item.dimensions.width>0 ? parseFloat(item.dimensions.width).toFixed(2) : 0,
                    "box_height": item && item.dimensions && item.dimensions.height && item.dimensions.height >0 ? parseFloat(item.dimensions.height).toFixed(2) : 0,
                    "box_dimension_unit": item && item.dimensions && item.dimensions.height_unit!=='' ? item.dimensions.height_unit :"",
                    "box_actual_weight": item && item.actual_weight >0 ?parseFloat(item.actual_weight).toFixed(2) : 0,
                    "box_weight_unit": item && item.weight_unit!=='' ? item.weight_unit :"",
                    "insurance_amount": item && item.insurance_amount && item.insurance_amount ? item.insurance_amount : "100"
                });
            })
        }
    }, [orderDetails])

    const [addLineItemData, setaddLineItemData] = useState({
        "line_item_id": getUniqueId(),
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "edit_line_item_id": "",
        "quantity": "",
        "tracking_number":"",
        "origin_country_code":"",
        "currency":""
    })

    const [lineItemErrors, setLineItemsErrors] = useState({
        "line_item_id": "",
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "quantity": "",
        "origin_country_code":"",
        "currency":""
    });

    const handleInputChange = e => {
        const { name, value } = e.target
        dispatchInputChangeCallback(name, value)
    }

    const ondrawerclose = () => {
        onClose(false);
    }

    const isFloatValue = (value) => {
        value = Number(value);
        if (!isNaN(value) && value.toString().indexOf('.') != -1) {
            return true;
        }
        return false;
    }
    const isIntegerValue = (value) => {
        value = Number(value);
        if (Number.isInteger(value)) {
            return true;
        }
        return false;
    }
    const validateLineItemData = () => {
        let isValid = true
        let lineItemErrorsTemp = {
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        };

        // if (addLineItemData.product_id == "" || addLineItemData.product_id === undefined  ||  addLineItemData.product_id === null) {
        //     isValid = false
        //     lineItemErrorsTemp.product_id = "Product id is required";
        // }
        if (addLineItemData.sku == "") {
            isValid = false
            lineItemErrorsTemp.sku = "SKU is required";
        }
        if (addLineItemData.product_desc == "" || addLineItemData.product_desc.length <= 1 || addLineItemData.product_desc.length >= 100) {
            isValid = false
            lineItemErrorsTemp.product_desc = "Product desc is required and should be more than 5 character long";
        }

        // if (addLineItemData.product_url == "" || addLineItemData.product_url.length >= 250) {
        //     isValid = false
        //     lineItemErrorsTemp.product_url = "Product url is required and should be valid";
        // }

        if (addLineItemData.product_price == "" || (!isFloatValue(addLineItemData.product_price) && !isIntegerValue(addLineItemData.product_price))) {
            isValid = false
            lineItemErrorsTemp.product_price = "Product price is required and should be valid";
        }

        if (addLineItemData.quantity == "" || !isIntegerValue(addLineItemData.quantity)) {
            isValid = false
            lineItemErrorsTemp.quantity = "Product quantity is required and should be a valid";
        }if (addLineItemData.currency == "") {
            isValid = false
            lineItemErrorsTemp.currency = "Currency is required";
        }if (addLineItemData.hs_tariff_code == ""  || addLineItemData.hs_tariff_code.replace(/\./g, '').length!==10) {
            isValid = false
            lineItemErrorsTemp.hs_tariff_code = "HsCode is required and Hscode must be 10 digits";
        }if (addLineItemData.origin_country_code == "") {
            isValid = false
            lineItemErrorsTemp.origin_country_code = "Country of origin is required";
        }

        setLineItemsErrors(lineItemErrorsTemp)
        return isValid
    }

    const formDataHandler = e => {
        const { name, value } = e.target
        setaddLineItemData({
            ...addLineItemData,
            [name]: value
        })
        validateLineItemData();
    }

    const dispatchHandler = e => {
        const { name, value } = e.target
        dispatch(fetchSkuINfo(value));
    }

    const handleBlur = e => {
        const { name, value } = e.target
        if (name === 'product_price' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: parseFloat(value).toFixed(2)
            })
        }
        if (name === 'product_desc' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: value.replace(/[^a-zA-Z0-9]/g, " ")
            })
        }
    }

    const handleHsCodeBlur = () => {
        const raw = addLineItemData.hs_tariff_code.replace(/\D/g, ''); // Remove non-digits
        
        if (raw.length === 10) {
            const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;

            setaddLineItemData(prev => {
                // 1. Start with the base update
                const newState = {
                    ...prev,
                    hs_tariff_code: formatted
                };

                // 2. Only add/update the inventory key if it already exists in the object
                if (Object.prototype.hasOwnProperty.call(prev, 'inventory_hs_tariff_code')) {
                    newState.inventory_hs_tariff_code = formatted;
                }

                return newState;
            });
        }
    };

    // const handleHsCodeBlur = () => {
    //     const raw = addLineItemData.hs_tariff_code.replace(/\D/g, ''); // Remove non-digits
    //     console.log(raw)
    //     if (raw.length === 10) {
    //         const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;

    //         setaddLineItemData(prev => ({
    //         ...prev,
    //             hs_tariff_code: formatted
    //         }));
    //     }
    // };

    const onAddLineItemModalClose = () => {
        setRemoveLineItemId("")
        setEditLineItemId("")
        setaddLineItemData({
            "line_item_id": getUniqueId(),
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "edit_line_item_id": "",
            "quantity": "",
            "tracking_number":"",
            "origin_country_code":"",
            "currency":""
        })
        setLineItemsErrors({
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        })
        setAddLineItemVisible(false)
    }

    const onSplitLineItemModalClose = () => {
        setSplitLineItemId("")
        setSplitLineItemVisible(false)
        setSplitQuantityCount("")
        setSplitQuantityError("")
    }

    const dispatchCountryCode = (id) => {
        setaddLineItemData({
            ...addLineItemData,
            ['origin_country_code']: id
        })
        validateLineItemData();
    }

    const onAddLineItemClick = () => {
        let userid = profile?.id || ""
        if (validateLineItemData()) {
            const customLineItemData = [...customLineItems];

            // --- CASE 1: ADD NEW ITEM ---
            if (addLineItemData.edit_line_item_id === "") {
                const { edit_line_item_id, ...newItemData } = addLineItemData;
                
                const updatedItems = [...customLineItemData, newItemData];
                setCustomLineItems(updatedItems);
                    const payload = {
                        item_reference_id: orderDetails && orderDetails.data && orderDetails.data.doc_id, 
                        action_type: 'ADD',
                        item_data: newItemData 
                    };
                    dispatch(patchOrderLineItems(payload, userid,meta));
                onAddLineItemModalClose();

            // --- CASE 2: EDIT EXISTING ITEM ---
            } else if (addLineItemData.edit_line_item_id !== "") {
                const originalItem = customLineItemData.find(i => i.line_item_id == addLineItemData.edit_line_item_id);
                
                // Whitelist of fields coming from the Form
                const formFields = [
                    'product_id', 'sku', 'product_desc', 'product_url', 
                    'product_price', 'hs_tariff_code', 'hs_tariff_code_country', 
                    'origin_country_code', 'quantity', 'currency'
                ];

                // Strict Dirty Check
                const isDirty = formFields.some(field => originalItem[field] !== addLineItemData[field]);

                if (isDirty) {
                    // Prepare the payload
                    const { edit_line_item_id, ...payloadData } = { ...addLineItemData };

                    // --- INVENTORY PROTECTION LOGIC ---
                    // If inventory exists, update the inventory field and RESTORE the original actual field
                    // This ensures the "actual" database field remains unchanged by this specific edit
                    if (payloadData.inventory_product_price !== undefined) {
                        payloadData.inventory_product_price = payloadData.product_price;
                        payloadData.product_price = originalItem.product_price; 
                    }
                    if (payloadData.inventory_hs_tariff_code !== undefined) {
                        payloadData.inventory_hs_tariff_code = payloadData.hs_tariff_code;
                        payloadData.hs_tariff_code = originalItem.hs_tariff_code;
                    }
                    if (payloadData.inventory_origin_country_code !== undefined) {
                        payloadData.inventory_origin_country_code = payloadData.origin_country_code;
                        payloadData.origin_country_code = originalItem.origin_country_code;
                    }
                    if (payloadData.inventory_hs_tariff_code_country !== undefined) {
                        payloadData.inventory_hs_tariff_code_country = payloadData.hs_tariff_code_country;
                        payloadData.hs_tariff_code_country = originalItem.hs_tariff_code_country;
                    }
                    if (payloadData.inventory_currency !== undefined) {
                        payloadData.inventory_currency = payloadData.currency;
                        payloadData.currency = originalItem.currency;
                    }
                    if (payloadData.inventory_sku !== undefined) {
                        payloadData.inventory_sku = payloadData.sku;
                        payloadData.sku = originalItem.sku;
                    }
                    if (payloadData.inventory_product_desc !== undefined) {
                        payloadData.inventory_product_desc = payloadData.product_desc;
                        payloadData.product_desc = originalItem.product_desc;
                    }
                    if (payloadData.inventory_product_url !== undefined) {
                        payloadData.inventory_product_url = payloadData.product_url;
                        payloadData.product_url = originalItem.product_url;
                    }
                    if (payloadData.inventory_product_id !== undefined) {
                        payloadData.inventory_product_id = payloadData.product_id;
                        payloadData.product_id = originalItem.product_id;
                    }

                    // Update Local UI State (Merge payload into existing list)
                    const updatedList = customLineItemData.map(item => {
                        if (item.line_item_id == addLineItemData.edit_line_item_id) {
                            return { ...item, ...payloadData };
                        }
                        return item;
                    });
                    
                    setCustomLineItems(updatedList);
                        const payload = {
                            item_reference_id: orderDetails && orderDetails.data && orderDetails.data.doc_id,
                            action_type: 'EDIT',
                            item_data: payloadData
                        };
                        dispatch(patchOrderLineItems(payload, userid,meta));
                } else {
                    console.log("No changes detected, skipping dispatch.");
                }
                
                onAddLineItemModalClose();
            } 

        } else {
            console.log("Validation errors in line items form");
        }
    };
    
    
    const splitLineItem = (item, count) => {
        const results = [];
        const totalQty = parseInt(item.quantity);
        const segmentQty = Math.floor(totalQty / count);
        const remainder = totalQty % count;

        for (let i = 0; i < count; i++) {
            results.push({
                ...item, 
                // The first item keeps the original ID so the backend 'EDIT' finds it
                // All other items get a brand new unique ID for the 'ADD' action
                line_item_id: i === 0 ? item.line_item_id : getUniqueId(), 
                // The first item gets the segment quantity + any remainder (e.g., 18/3 = 6)
                quantity: i === 0 ? (segmentQty + remainder) : segmentQty,
                is_packed: false
            });
        }
        return results;
    };

    // const onSplitLineItemClick = () => {
    //     let splitLineItemData = _.find(customLineItems, ['line_item_id', splitLineItemId])
    //     if(splitQuantityCount>1 && /^-?\d*$/.test(splitQuantityCount) && splitQuantityCount <= parseInt(splitLineItemData.quantity)){
    //         const splitItems = splitLineItem(splitLineItemData, splitQuantityCount);
    //         let customLineItemData = [...customLineItems];
    //         let newLineItemData = [];
    //         customLineItemData.map((item) => {
    //             if (item && item.line_item_id && item.line_item_id != splitLineItemId) {
    //                 newLineItemData.push(item)
    //             }
    //         })
    //         setCustomLineItems(newLineItemData)
    //         splitItems.map((item) => {
    //             newLineItemData.push(item)
    //         })
    //         setCustomLineItems(newLineItemData)
    //         setSplitLineItemVisible(false)
    //     }else{
    //         setSplitQuantityError("split count should be less than or equal to the actual quantity")
    //     }
    // }

    

    const onSplitLineItemClick = () => {
        let userid = profile?.id || "";
        let originalSplitItem = _.find(customLineItems, ['line_item_id', splitLineItemId]);

        const count = parseInt(splitQuantityCount);

        if (count > 1 && count <= parseInt(originalSplitItem.quantity)) {
            // 1. Generate all segments locally
            const splitItems = splitLineItem(originalSplitItem, count);

            // 2. Prepare ONE single payload for the backend
            const payload = {
                item_reference_id: orderDetails?.data?.doc_id,
                action_type: 'SPLIT',
                item_data: {
                    original_line_item_id: splitLineItemId,
                    new_items: splitItems // Array of all 6 new items
                }
            };

            // 3. Dispatch once
            dispatch(patchOrderLineItems(payload, userid, meta));

            // 4. Update local state immediately
            const otherItems = customLineItems.filter(item => item.line_item_id !== splitLineItemId);
            setCustomLineItems([...otherItems, ...splitItems]);
            
            setSplitLineItemVisible(false);
        }
    };
    const updateButtonDisable = (item) => {
        let updateButtonDisable = true;
            if (!item.tracking_number || item.tracking_number === "" || item.tracking_number === " ") {
                updateButtonDisable = false;
            }
        return updateButtonDisable;
    }
    function generate4DigitNumber() {
        const now = new Date();
        const seconds = now.getSeconds(); // 0–59
        const milliseconds = now.getMilliseconds(); // 0–999

        // Combine seconds and milliseconds to seed randomness
        const seed = seconds * 1000 + milliseconds;

        // Use seed to generate a 4-digit number
        const random = Math.floor((Math.random() * seed) % 10000);

        // Pad with leading zeros if needed
        return random.toString().padStart(4, '0');
    }
    const onLineItemsChange = (items) => {
        if (items) {
            let productLineItem = [];
            items.forEach((item) => {
                if (item) {
                    let mappedItem = {
                        "line_item_id": item.line_item_id || getUniqueId(),
                        "product_id": item.product_id || "",
                        "sku": item.sku || "",
                        "product_desc": (item.product_desc || "").replace(/[^a-zA-Z0-9]/g, " "),
                        // Store standard price exactly as it is in the source
                        "product_price": item.product_price ? parseFloat(String(item.product_price).replace('$', '')).toFixed(2) : "",
                        "quantity": item.quantity || "",
                        "tracking_number": (item && item.tracking_number && item.tracking_number != "" ) ? item.tracking_number : "",
                        "currency": item.currency || "",
                        "hs_tariff_code": item.hs_tariff_code || "",
                        "hs_tariff_code_country": item.hs_tariff_code_country || "",
                        "origin_country_code": item.origin_country_code || "",
                        "is_packed": item.is_packed ?? false,
                        "location": item.location || {},
                    };

                    // DYNAMICALLY ADD ALL INVENTORY KEYS (preserves inventory_product_price separately)
                    Object.keys(item).forEach(key => {
                        if (key.startsWith('inventory_')) {
                            mappedItem[key] = item[key];
                        }
                    });

                    productLineItem.push(mappedItem);
                }
            });

            const sortedLineItems = productLineItem.sort((a, b) => {
                const aDisabled = a.tracking_number && a.tracking_number !== "" ? 1 : 0;
                const bDisabled = b.tracking_number && b.tracking_number !== "" ? 1 : 0;
                return aDisabled - bDisabled;
            });

            setCustomLineItems(sortedLineItems);
        }
    };

    const handleSubmit=()=>{
        let orderid=orderDetails && orderDetails.data && orderDetails.data.order_details && orderDetails.data.order_details.orderid
        let data={
            "customer_info":values,
            "doc_id":orderDetails && orderDetails.data && orderDetails.data.doc_id,
            "orderid":orderid,
        }
        Object.assign(data, dimensionValue);
        dispatch(orderUpdateData(profile && profile.id,data,meta))
    }

    const handleDeleteItem = (lineItemId) => {
        let userid = profile?.id || "";
        const originalItem = customLineItems.find(i => i.line_item_id === lineItemId);
        
        if (!originalItem) return;

        // 1. Update Local UI State immediately
        const updatedList = customLineItems.filter(item => item.line_item_id !== lineItemId);
        setCustomLineItems(updatedList);

        // 2. Sync with Backend
        const payload = {
            item_reference_id: orderDetails?.data?.doc_id,
            action_type: 'DELETE',
            // We pass the ID inside item_data so the backend knows which one to remove
            item_data: { line_item_id: lineItemId } 
        };
        dispatch(patchOrderLineItems(payload, userid, meta));
        
        // Clean up state
        setDeleteConfirmOpen(false);
        setItemToDelete(null);
    };

    useEffect(() => {
        if (lineItemsData.length != 0) {
            onLineItemsChange(lineItemsData)
        }
    }, [lineItemsData])

    useEffect(() => {
            if (skuInfos && skuInfos.data && skuInfos.data.skuinfos && skuInfos.data.skuinfos.length > 0) {
                setSkuInfo(skuInfos.data.skuinfos && skuInfos.data.skuinfos.length > 0 ? skuInfos.data.skuinfos : [])
            }
            
            if (skuInfos && skuInfos.data && skuInfos.data.skuDatas && Object.keys(skuInfos.data.skuDatas).length > 0) {
                const item = skuInfos.data.skuDatas;
    
                // 1. Identify priority values for UI Display
                const displayPrice = item.product_price || "";
                const displayHs = item.hs_tariff_code || "";
                const displayCoo = item.origin_country_code || "";
                 // Product ID auto-generation needs to be removed, as requested by Vijay. (2026-05-14)
                // 2. Build the Base Object with standard keys (for the Form Inputs)
                let baseData = {
                    product_id:item.product_id || "",
                    sku: item.sku,
                    product_desc:item.product_desc || "",
                    product_url: item.product_url || "",
                    product_price: displayPrice,
                    hs_tariff_code: displayHs,
                    hs_tariff_code_country: item.hs_tariff_code_country || "",
                    quantity: 1 || "",
                    tracking_number: "",
                    origin_country_code: displayCoo,
                    currency:item.inventory_currency || item.currency || ""
                };
    
                /**
                 * 3. DYNAMIC INVENTORY PREFIXING
                 * Loop through the raw item data. 
                 * Exclude technical IDs, then add prefix to everything else.
                 */
                Object.keys(item).forEach(key => {
                    // Skip the keys you want to keep standard
                    if (key === "line_item_id" || key === "edit_line_item_id" || key === "quantity") {
                        return; 
                    }
    
                    // If it's already an inventory key, just keep it
                    if (key.startsWith('inventory_')) {
                        baseData[key] = item[key];
                    } else {
                        // For all other keys (sku, product_desc, etc.), create the inventory_ counterpart
                        baseData[`inventory_${key}`] = item[key];
                    }
                });
    
                // 4. Set State with correct Line Item ID handling
                if (editLineItemId !== "") {
                    setaddLineItemData({ 
                        ...baseData, 
                        line_item_id: editLineItemId, 
                        edit_line_item_id: editLineItemId 
                    });
                } else {
                    setaddLineItemData({ 
                        ...baseData, 
                        line_item_id: getUniqueId(), 
                        edit_line_item_id: "" 
                    });
                }
                
                // 5. Validation/Error cleanup
                setLineItemsErrors(prev => ({
                    ...prev,
                    sku: item.sku ? "" : prev.sku,
                    product_desc: item.product_desc ? "" : prev.product_desc,
                    product_price: baseData.product_price ? "" : prev.product_price,
                    hs_tariff_code: baseData.hs_tariff_code ? "" : prev.hs_tariff_code,
                    origin_country_code: baseData.origin_country_code ? "" : prev.origin_country_code,
                    quantity: "",
                    currency: item.currency ? "" : prev.currency
                }));
    
            } else {
               // Reset Logic / Manual Entry Mode
                setaddLineItemData(prev => {
                    // Determine the ID: 
                    // 1. If we are editing, use the existing edit ID.
                    // 2. If it's a new entry and prev already has an ID, keep it.
                    // 3. Otherwise, generate a fresh one.
                    const finalId = editLineItemId !== "" 
                        ? editLineItemId 
                        : (prev.line_item_id ? prev.line_item_id : getUniqueId());

                    return {
                        ...prev,
                        line_item_id: finalId,
                        edit_line_item_id: editLineItemId !== "" ? editLineItemId : "",
                        product_id: "",
                        product_desc: "",
                        product_url: "",
                        product_price: "",
                        hs_tariff_code: "",
                        hs_tariff_code_country: "",
                        origin_country_code: "",
                        quantity: 1,
                        currency: "",
                        // sku: prev.sku is already preserved by ...prev
                    };
                });
            }
        }, [skuInfos]);
    


    useEffect(() => {
            if (editLineItemId === "" || editLineItemId === "undefined" ){
                setaddLineItemData({
                    "line_item_id": getUniqueId(),
                    "product_id": "",
                    "sku":"",
                    "product_desc": "",
                    "product_url": "",
                    "product_price": "",
                    "hs_tariff_code": "",
                    "hs_tariff_code_country": "",
                    "edit_line_item_id": "",
                    "quantity": "",
                    "tracking_number":"",
                    "origin_country_code":"",
                    "currency":""
                })
            }
            if(!addLineItemVisible){
                dispatch(resetLineItemSettingsState());
            }
        }, [addLineItemVisible])
    const history = useHistory();
    useEffect(() => {
        if (orderUpdate && orderUpdate.notification && orderUpdate.notification.messageContent && orderUpdate.notification.messageContent[0] === 'Order updated successfully') {
            const currentOrderId = orderDetails?.data?.order_details?.orderid;
            if (currentOrderId) {
                // ─── 1. FETCH REFRESHED ORDER DETAILS ───
                dispatch(fetchOrderDetail(currentOrderId));

                // ─── 2. UPDATE URL WITH QUERY PARAMETER ───
                history.push(`/orders/all?orderid=${currentOrderId}`);
            }
            ondrawerclose()
            let orderDocIdDatas=[];
            if(invalidDocIds!==null && Object.keys(invalidDocIds).length>0){
                if(invalidDocIds.invalid_order_docids && invalidDocIds.invalid_order_docids.length>0){
                    invalidDocIds.invalid_order_docids.map((item) => {
                        orderDocIdDatas.push(item.docIds)
                    })
                }
                if(invalidDocIds.valid_order_docids && invalidDocIds.valid_order_docids.length>0){
                    invalidDocIds.valid_order_docids.map((item) => {
                        orderDocIdDatas.push(item)
                    })
                }
                let final_data={
                    "order_docids":orderDocIdDatas,
                    "request_type":"CREATE_SHIPMENT"
                }
                if(orderDocIdDatas.length>0){
                    dispatch(postBulkOrderValidation(profile && profile.id,final_data))
                }
            }
        }
    }, [orderUpdate])

    useEffect(() => {
        if (removeLineItemId != "" && removeLineItemId != "undefined") {
            let customLineItemData = [...customLineItems];
            let newLineItemData = [];
            customLineItemData.map((item) => {
                if (item && item.line_item_id && item.line_item_id != removeLineItemId) {
                    newLineItemData.push(item)
                }
            })
            setCustomLineItems(newLineItemData)
        }
    }, [removeLineItemId])

    useEffect(() => {
            if (editLineItemId != "" && editLineItemId != "undefined" && !_.isUndefined(_.find(customLineItems, ['line_item_id', editLineItemId]))) {
                let editData = { ..._.find(customLineItems, ['line_item_id', editLineItemId]) };
    
                // --- UI DISPLAY PRIORITY LOGIC ---
                // If inventory keys exist, show them in the form fields instead of actual values
                if (editData.inventory_product_price !== undefined) {
                    editData.product_price = editData.inventory_product_price;
                }
                if (editData.inventory_hs_tariff_code !== undefined) {
                    editData.hs_tariff_code = editData.inventory_hs_tariff_code;
                }
                
                if (editData.inventory_currency !== undefined) {
                    editData.currency = editData.inventory_currency;
                }
                if (editData.inventory_origin_country_code !== undefined) {
                    editData.origin_country_code = editData.inventory_origin_country_code;
                }
                if (editData.inventory_product_desc !== undefined) {
                    editData.product_desc = editData.inventory_product_desc;
                }
                if (editData.inventory_product_url !== undefined) {
                    editData.product_url = editData.inventory_product_url;
                }
                if (editData.inventory_sku !== undefined) {
                    editData.sku = editData.inventory_sku;
                }
                if (editData.inventory_product_id !== undefined) {
                    editData.product_id = editData.inventory_product_id;
                }
    
                editData[`edit_line_item_id`] = editLineItemId;
                setaddLineItemData(editData);
                setAddLineItemVisible(true);
            }
        }, [editLineItemId]);

    useEffect(() => {
        if (splitLineItemId != "" && splitLineItemId != "undefined" && !_.isUndefined(_.find(customLineItems, ['line_item_id', splitLineItemId]))) {
            setSplitLineItemVisible(true)
        }
    }, [splitLineItemId])

    useEffect(() => {
        let tempBoxData=[]
        let customValue={"_id":0,"box_name":"custom"}
        tempBoxData.push(customValue)
        let boxOriginalData = box && box.data.filter(function( obj ) {
            return  obj.hide !== true;
            });
        if (boxOriginalData.length !== 0) {
            boxOriginalData.map((item) => {
                tempBoxData.push(item)
            })
            setBoxData(tempBoxData)
        }else{
            setBoxData(tempBoxData)
        }
    }, [box && box.data]);

    const columns = [
        // {
        //     field: 'product_id',
        //     headerName: 'Product Id',
        //     sortable: false,
        //     flex: 1,
        //     renderCell: (params) => {
        //         if (params.row.product_id && typeof params.row.product_id !== "undefined") {
        //             return params.row.product_id
        //         } else {
        //             return "-"
        //         }
        //     }
        // },
        {
            field: 'sku',
            headerName: 'SKU',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
               const sku = params.row.inventory_sku ?? params.row.sku;
                return sku && sku !== "" ? sku : "-";
            }
        },
        {
            field: 'product_desc',
            headerName: 'Product Desc',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                const desc = params.row.inventory_product_desc ?? params.row.product_desc;
                return desc && desc !== "" ? desc : "-";
            }
        },
        {
            field: 'tracking_number',
            headerName: 'Tracking Number',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                let tracking_number = (params.row.tracking_number && typeof params.row.tracking_number !== "undefined" && params.row.tracking_number !== null)
                    ? params.row.tracking_number : "";
                let carrier_name = (params.row.fulfilment_company && typeof params.row.fulfilment_company !== "undefined" && params.row.fulfilment_company !== null)
                    ? params.row.fulfilment_company : "";
                let tracking = { "tracking_number": tracking_number, "carrier_name": carrier_name }
                return (
                    <CarrierTracking trackingItems={tracking} carrierImageWidth="60px" />
                )
            }
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                if (params.row.quantity && typeof params.row.quantity !== "undefined") {
                    return params.row.quantity
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'product_price',
            headerName: 'Price',
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                const price = params.row.inventory_product_price ?? params.row.product_price;
                return price && price !== "" ? price : "-";
            }
        },
         {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            width: 200,
            hide: (customLineItems.length == 0),
            renderCell: (params) => {
                if (params.row && params.row.line_item_id && params.row.line_item_id != "") {
                    return <>
                        <span>
                            <Tooltip title="Edit" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <EditIcon style={{   color: updateButtonDisable(params.row) ? 'rgba(0,0,0,.54)' : '#1890ff', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'none' : 'auto' }} onClick={() => {
                                        setEditLineItemId(params.row.line_item_id)
                                        }
                                        } />
                                </IconButton>
                            </Tooltip>
                        </span>
                        <span>
                            <Tooltip title="Split" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <CallSplitOutlinedIcon style={{  color: updateButtonDisable(params.row) ? 'rgba(0,0,0,.54)' : '#1890ff', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'none' : 'auto' }} onClick={() => {
                                        setSplitLineItemId(params.row.line_item_id)
                                        }
                                        } />
                                </IconButton>
                            </Tooltip>
                        </span>
                        <span>
                            <Tooltip title="Delete" placement="left-start">
                                <IconButton 
                                    disabled={updateButtonDisable(params.row)}
                                    onClick={() => {
                                        setItemToDelete(params.row.line_item_id);
                                        setDeleteConfirmOpen(true);
                                    }}
                                >
                                    <DeleteOutlineOutlinedIcon 
                                        style={{ 
                                            color: updateButtonDisable(params.row) ? 'rgba(0,0,0,.54)' : '#d32f2f' 
                                        }} 
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </>;
                } else {
                    return <>-</>;
                }
            }
        }
    ]
    
    return (
        <>
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: drawerWidth },
                }}
            >
               
                {orderDetails && orderDetails.loading === true && <>
                    <Box style={{
                        position: 'absolute', left: '50%', top: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <CircularProgress />
                    </Box>
                </>
                }
                <Modal
                    open={splitLineItemVisible}
                    onClose={onSplitLineItemModalClose}
                >
                    <Box sx={modalStyle}>
                        <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                            <CardHeader title={"Quantity Split"} />
                            <Divider />
                            <CardContent>
                                {/* Information Note */}
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        backgroundColor: '#e3f2fd', 
                                        color: '#0d47a1', 
                                        padding: '10px', 
                                        borderRadius: '4px', 
                                        mb: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '0.85rem',
                                        fontWeight: 500
                                    }}
                                >
                                    <strong>Note:</strong>&nbsp;Changes apply to this order only. Inventory and other orders will not be updated.
                                </Typography>

                                <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                    <TextField 
                                        id="standard-basic"
                                        label="Quantity Split Count"
                                        variant="standard"
                                        name="split_count" // Renamed from product_id for clarity
                                        type="number"      // Ensures numeric keyboard on mobile
                                        onInput={(e) => {
                                            setSplitQuantityCount(e.target.value)
                                        }}
                                        style={{ width: "100%", margin: '8px' }}
                                        error={!!splitQuantityError}
                                        helperText={splitQuantityError}
                                    />
                                </div>
                                
                                <div className="sc--form--center" style={{ marginTop: "15px" }}>
                                    <Button
                                        variant="contained"
                                        onClick={onSplitLineItemClick}
                                        disabled={splitQuantityCount === ""} // Use standard disabled prop
                                        style={{
                                            marginLeft: "20px",
                                            // Style automatically handled by 'disabled' prop
                                        }}>
                                        Submit
                                    </Button>
                                </div>
                            </CardContent>
                        </Card>
                    </Box>
                </Modal>
               <Modal
                    open={deleteConfirmOpen}
                    onClose={() => setDeleteConfirmOpen(false)}
                >
                    <Box sx={modalStyle}>
                        <Card sx={{ minWidth: 450 }} className="sc--cardhead--details">
                            <CardHeader title="Confirm Deletion" />
                            <Divider />
                            <CardContent>
                                {/* The Note */}
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        backgroundColor: '#e3f2fd', 
                                        color: '#0d47a1', 
                                        padding: '10px', 
                                        borderRadius: '4px', 
                                        mb: 2,
                                        fontSize: '0.85rem',
                                        fontWeight: 500
                                    }}
                                >
                                    <strong>Note:</strong>&nbsp;Changes apply to this order only. Inventory and other orders will not be updated.
                                </Typography>

                                <Typography variant="body1" sx={{ mb: 3, mt: 2 }}>
                                    Are you sure you want to remove this line item from this shipment?
                                </Typography>

                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => setDeleteConfirmOpen(false)}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="error"
                                        onClick={() => handleDeleteItem(itemToDelete)}
                                    >
                                        Confirm Delete
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                </Modal>
                <AddLineItem
                    addLineItemVisible={addLineItemVisible}
                    onAddLineItemModalClose={onAddLineItemModalClose}
                    formDataHandler={formDataHandler}
                    dispatchHandler={dispatchHandler}
                    dispatchCountryCode={dispatchCountryCode}
                    onAddLineItemClick={onAddLineItemClick}
                    addLineItemData={addLineItemData}
                    editLineItemId={editLineItemId}
                    errors={lineItemErrors}
                    handleBlur={handleBlur}
                    handleHsCodeBlur={handleHsCodeBlur}
                    skuOnly={skuInfo}
                />
                {orderDetails && orderDetails.loading === false &&
                <div style={{ padding: "0 30px" }}>
                       <Card 
                            sx={{ 
                                margin: '20px 0', 
                                borderRadius: '8px 8px 0 0', // Rounded top corners
                                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                                border: '1px solid #e0e0e0',
                                backgroundColor: '#fff',
                                overflow: 'hidden'
                            }} 
                            className="sc--cardhead--details"
                        >
                            <CardHeader 
                                title={
                                    <Typography 
                                        variant="h6" 
                                        sx={{ 
                                            fontWeight: 700, 
                                            fontSize: '1.1rem', 
                                            color: '#111827', // Slate grey/black
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        Order Details Update
                                    </Typography>
                                } 
                                sx={{
                                    backgroundColor: '#f9fafb', // Soft professional background
                                    padding: '12px 24px',
                                    borderBottom: '1px solid #e0e0e0'
                                }}
                                action={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Box 
                                            sx={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                borderRadius: '6px', 
                                                backgroundColor: 'rgba(0,0,0,0.03)',
                                                px: 1,
                                                mr: 1
                                            }}
                                        >
                                            <WidthMaximize
                                                defaultWidth="80%"
                                                onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                            />
                                        </Box>
                                        
                                        <Tooltip title="Close Drawer">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#6b7280', 
                                                    '&:hover': { 
                                                        backgroundColor: '#fee2e2', 
                                                        color: '#dc2626' 
                                                    },
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                } 
                            />
                            
                            {/* Loading Indicator pinned to the header bottom */}
                            {(orderUpdate?.loading || orderUpdate?.loading) && (
                                <LinearProgress 
                                    sx={{ 
                                        height: 3, 
                                        backgroundColor: 'transparent',
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#1976d2'
                                        }
                                    }} 
                                />
                            )}
                        </Card>
                        <Card 
                            sx={{ 
                                margin: '20px 0', 
                                boxShadow: '0 2px 12px rgba(0,0,0,0.08)', 
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }} 
                            className="sc--cardhead--details"
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Grid container spacing={3} alignItems="stretch">
                                    
                                    {/* Customer Information Section */}
                                    <Grid item xs={12} md={6}>
                                        <Card sx={{ height: '100%', boxShadow: 'none', border: '1px solid #eee', borderRadius: '8px' }}>
                                            <CardHeader 
                                                title={<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#374151' }}>Customer Information</Typography>} 
                                                sx={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #eee', py: 1.5 }}
                                            />
                                            <Divider />
                                            <CardContent sx={{ p: 3 }}>
                                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                    <TextField 
                                                        label="First Name" 
                                                        variant="standard" 
                                                        name="customer_firstname"
                                                        value={values.customer_firstname} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.customer_firstname} 
                                                        helperText={errors.customer_firstname}
                                                        fullWidth 
                                                    />
                                                    <TextField 
                                                        label="Last Name" 
                                                        variant="standard" 
                                                        name="customer_lastname"
                                                        value={values.customer_lastname} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.customer_lastname} 
                                                        helperText={errors.customer_lastname}
                                                        fullWidth 
                                                    />
                                                </Box>
                                                <TextField 
                                                    label="Email Address" 
                                                    variant="standard" 
                                                    name="customer_email"
                                                    value={values.customer_email} 
                                                    onChange={handleInputChange}
                                                    error={!!errors.customer_email} 
                                                    helperText={errors.customer_email}
                                                    fullWidth sx={{ mb: 2 }} 
                                                />
                                                <TextField 
                                                    label="Phone Number" 
                                                    variant="standard" 
                                                    name="customer_phone"
                                                    value={values.customer_phone} 
                                                    onChange={handleInputChange}
                                                    error={!!errors.customer_phone} 
                                                    helperText={errors.customer_phone}
                                                    fullWidth 
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    {/* Delivery Address Section */}
                                    <Grid item xs={12} md={6}>
                                        <Card sx={{ height: '100%', boxShadow: 'none', border: '1px solid #eee', borderRadius: '8px' }}>
                                            <CardHeader 
                                                title={<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#374151' }}>Delivery Address</Typography>} 
                                                sx={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #eee', py: 1.5 }}
                                            />
                                            <Divider />
                                            <CardContent sx={{ p: 3 }}>
                                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                    <TextField 
                                                        label="First Name" 
                                                        variant="standard" 
                                                        name="receiver_first_name"
                                                        value={values.receiver_first_name} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.receiver_first_name} 
                                                        helperText={errors.receiver_first_name}
                                                        fullWidth 
                                                    />
                                                    <TextField 
                                                        label="Last Name" 
                                                        variant="standard" 
                                                        name="receiver_last_name"
                                                        value={values.receiver_last_name} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.receiver_last_name} 
                                                        helperText={errors.receiver_last_name}
                                                        fullWidth 
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                    <TextField 
                                                        label="Address Line 1" 
                                                        variant="standard" 
                                                        name="address1"
                                                        value={values.address1} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.address1} 
                                                        helperText={errors.address1}
                                                        fullWidth 
                                                    />
                                                    <TextField 
                                                        label="Address Line 2" 
                                                        variant="standard" 
                                                        name="address2"
                                                        value={values.address2} 
                                                        onChange={handleInputChange}
                                                        fullWidth 
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                    <TextField 
                                                        label="City" 
                                                        variant="standard" 
                                                        name="city"
                                                        value={values.city} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.city} 
                                                        helperText={errors.city}
                                                        fullWidth 
                                                    />
                                                    <TextField 
                                                        label="Zip Code" 
                                                        variant="standard" 
                                                        name="zip"
                                                        value={values.zip} 
                                                        onChange={handleInputChange}
                                                        error={!!errors.zip} 
                                                        helperText={errors.zip}
                                                        fullWidth 
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex', gap: 2 }}>
                                                    <Box sx={{ flex: 1 }}><CountryDropdown values={values} dispatchCountryCallback={dispatchCountryCallback} /></Box>
                                                    <Box sx={{ flex: 1 }}><ProvinceDropdown values={values} dispatchProvinceCallback={dispatchProvinceCallback} /></Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    {/* Product Dimensions Section */}
                                    <Grid item xs={12}>
                                        <Card sx={{ boxShadow: 'none', border: '1px solid #eee', borderRadius: '8px' }}>
                                            <CardHeader 
                                                title={<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#374151' }}>Product Dimensions</Typography>} 
                                                sx={{ backgroundColor: '#f9fafb', borderBottom: '1px solid #eee', py: 1.5 }}
                                            />
                                            <Divider />
                                            <CardContent sx={{ p: 3 }}>
                                                <Autocomplete
                                                    name="choosenmeasurement"
                                                    options={boxData}
                                                    autoHighlight
                                                    loading={box && box.loading}
                                                    getOptionLabel={(option) => 
                                                        option.box_name === 'custom' ? "Custom Measurement" : 
                                                        `${option.box_name} (${option.box_length}${option.box_length_unit} x ${option.box_width}${option.box_width_unit} x ${option.box_height}${option.box_height_unit}, ${option.box_weight}${option.box_weight_unit})`
                                                    }
                                                    filterOptions={filterOptions}
                                                    value={getChooseMeasurement(dimensionValue._id)}
                                                    onChange={(event, value) => {
                                                        if (value !== null) {
                                                            onBoxDimensionChange({ target: { name: "choosenmeasurement", value: value._id } });
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params} label="Choose Saved Measurement" variant="standard" fullWidth />}
                                                    sx={{ mb: 4 }}
                                                />

                                                <Grid container spacing={3}>
                                                    <Grid item xs={6} md={2.4}>
                                                        <TextField 
                                                            label="Length" variant="standard" name="box_length" type="number" fullWidth
                                                            value={dimensionValue.box_length} onChange={onBoxDimensionChange}
                                                            error={!!dimensionsErrors.box_length} helperText={dimensionsErrors.box_length}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} md={2.4}>
                                                        <TextField 
                                                            label="Width" variant="standard" name="box_width" type="number" fullWidth
                                                            value={dimensionValue.box_width} onChange={onBoxDimensionChange}
                                                            error={!!dimensionsErrors.box_width} helperText={dimensionsErrors.box_width}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} md={2.4}>
                                                        <TextField 
                                                            label="Height" variant="standard" name="box_height" type="number" fullWidth
                                                            value={dimensionValue.box_height} onChange={onBoxDimensionChange}
                                                            error={!!dimensionsErrors.box_height} helperText={dimensionsErrors.box_height}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} md={4.8}>
                                                        <FormControl variant="standard" fullWidth error={!!dimensionsErrors.box_dimension_unit}>
                                                            <InputLabel>Dimension Unit</InputLabel>
                                                            <Select name="box_dimension_unit" value={dimensionValue.box_dimension_unit} onChange={onBoxDimensionChange}>
                                                                <MenuItem value="in">Inches (in)</MenuItem>
                                                                <MenuItem value="cm">Centimeters (cm)</MenuItem>
                                                            </Select>
                                                            <FormHelperText>{dimensionsErrors.box_dimension_unit}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <TextField 
                                                            label="Actual Weight" variant="standard" name="box_actual_weight" type="number" fullWidth
                                                            value={dimensionValue.box_actual_weight} onChange={onBoxDimensionChange}
                                                            error={!!dimensionsErrors.box_actual_weight} helperText={dimensionsErrors.box_actual_weight}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <FormControl variant="standard" fullWidth error={!!dimensionsErrors.box_weight_unit}>
                                                            <InputLabel>Weight Unit</InputLabel>
                                                            <Select name="box_weight_unit" value={dimensionValue.box_weight_unit} onChange={onBoxDimensionChange}>
                                                                <MenuItem value="lb">Pounds (lb)</MenuItem>
                                                                <MenuItem value="kg">Kilograms (kg)</MenuItem>
                                                                <MenuItem value="g">Grams (g)</MenuItem>
                                                            </Select>
                                                            <FormHelperText>{dimensionsErrors.box_weight_unit}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <TextField 
                                                            label="Insurance Amount (Optional)" variant="standard" name="insurance_amount" type="number" fullWidth
                                                            value={dimensionValue.insurance_amount} onChange={onBoxDimensionChange}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>

                                    {/* Footer Action Area */}
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
                                            <Button
                                                variant="contained"
                                                onClick={handleSubmit}
                                                sx={{ 
                                                    px: 6, 
                                                    py: 1, 
                                                    borderRadius: '6px', 
                                                    textTransform: 'none', 
                                                    fontWeight: 600,
                                                    boxShadow: '0 4px 6px rgba(25, 118, 210, 0.2)',
                                                    '&:hover': { boxShadow: '0 6px 12px rgba(25, 118, 210, 0.3)' }
                                                }}
                                            >
                                                Update Order Details
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                         <Card 
                            sx={{ 
                                margin: '20px 0', 
                                boxShadow: '0 2px 10px rgba(0,0,0,0.08)', // Subtle shadow for enterprise look
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }} 
                            className="sc--cardhead--details"
                        >
                            <CardContent sx={{ p: '0 !important' }}> {/* Remove default padding to let the inner card breathe */}
                                <Grid item xs={12} md={12}>
                                    <Card sx={{ boxShadow: 'none', borderRadius: 0 }}>
                                        <CardHeader 
                                            title={
                                                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem', color: '#333' }}>
                                                    Product Details
                                                </Typography>
                                            } 
                                            className="sc--cardhead--details" 
                                            sx={{ 
                                                backgroundColor: '#f8f9fa', // Soft professional grey header
                                                borderBottom: '1px solid #e0e0e0',
                                                py: 1.5
                                            }}
                                            action={
                                                <Button 
                                                    variant="outlined" 
                                                    size="small"
                                                    startIcon={<AddIcon />} // Optional: import AddIcon from @mui/icons-material
                                                    onClick={() => setAddLineItemVisible(true)}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        borderRadius: '6px',
                                                        px: 2,
                                                        mt: 0.5,
                                                        borderColor: '#1976d2',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                                            borderColor: '#115293',
                                                        }
                                                    }}
                                                >
                                                    Add Line Item
                                                </Button>
                                            }
                                        />
                                        
                                        <CardContent 
                                            className="sc--product--table" 
                                            sx={{ p: 0 }} // Table should touch edges for professional look
                                        >
                                            <DataGrid
                                                // Keeping your exact logic
                                                getRowId={(row) => row.line_item_id + Math.random()}
                                                rows={customLineItems}
                                                columns={columns}
                                                autoHeight={true}
                                                hideFooter={true}
                                                disableColumnMenu // Enterprise tables usually keep it simple
                                                disableRowSelectionOnClick
                                                sx={{
                                                    border: 'none', // Remove outer grid border
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        backgroundColor: '#fff',
                                                        borderBottom: '2px solid #f0f0f0',
                                                        color: '#666',
                                                        fontSize: '0.85rem',
                                                        textTransform: 'uppercase',
                                                        letterSpacing: '0.5px',
                                                        fontWeight: 700
                                                    },
                                                    '& .MuiDataGrid-cell': {
                                                        borderBottom: '1px solid #f5f5f5',
                                                        fontSize: '0.9rem',
                                                        py: 1
                                                    },
                                                    '& .MuiDataGrid-row:hover': {
                                                        backgroundColor: '#fcfcfc', // Very subtle hover
                                                    },
                                                    '& .MuiDataGrid-columnHeaderTitle': {
                                                        fontWeight: 'bold !important',
                                                    }
                                                }}
                                                slots={{
                                                    noRowsOverlay: NorowsData, // Corrected key to noRowsOverlay
                                                    loadingOverlay: LinearProgress,
                                                }}
                                                loading={orderDetails && orderDetails.loading}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </CardContent>
                        </Card>
                </div>
                }
            </Drawer >
        </>
    )
}


export default OrderDetailsEditDrawer;